const DEFAULT_STATUS = {
  flowId: '',
  successText: '',
  successTextHtml: '',
  actions: [],
  referer: '',
  shopId: null
};

export default {
  namespace: 'success',

  state: DEFAULT_STATUS,

  effects: {

  },

  reducers: {
    setSuccessField(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    clearSuccessField(state) {
      return {
        ...state,
        ...DEFAULT_STATUS,
      }
    }
  },
};
